export async function readFileAsText( file:File ):Promise<string>
{
  let promise = new Promise<string>(
    ( resolve, reject )=>
    {
      let reader = new FileReader();
      reader.addEventListener( "load",
        ( e )=>
        {
          resolve( reader.result as string );
        },
        false
      )
      reader.readAsText( file );
    }
  )

  return promise;
  
}